import type { MFAType } from '@/components/mfaForm/MFACodeForm.types';

export enum AuthenticateGrantType {
  AUTHORIZATION_CODE = 'AUTHORIZATION_CODE',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
}

export enum AuthenticateStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  MFA_CHALLENGE = 'MFA_CHALLENGE',
  FAILED = 'FAILED',
  FAILED_LAST_ATTEMPT_LEFT = 'FAILED_LAST_ATTEMPT_LEFT',
  INCORRECT_REQUEST = 'INCORRECT_REQUEST',
}

export enum CodeChallengeMethod {
  S256 = 'S256',
}

export enum AuthenticateScope {
  FULL = 'FULL',
}

export interface AuthenticateRequest {
  login: string;
  password: string;
  grantType: AuthenticateGrantType;
  scope: AuthenticateScope;
  clientId: string;
  redirectUri: string;
  state: string;
  b64CodeChallenge: string;
  codeChallengeMethod: CodeChallengeMethod;
  deviceId: string;
}

export interface AuthenticateSuccessfulResponse {
  status: AuthenticateStatus.SUCCESSFUL;
  code: string;
  state: string;
  redirectUri: string;
}

export interface AuthenticateMfaChallengeResponse {
  status: AuthenticateStatus.MFA_CHALLENGE;
  mfaCode: string;
  mfaCodeSentTo: string;
  mfaType: MFAType;
}

export interface AuthenticateFailureResponse {
  status:
    | AuthenticateStatus.FAILED
    | AuthenticateStatus.FAILED_LAST_ATTEMPT_LEFT
    | AuthenticateStatus.INCORRECT_REQUEST;
}

export type AuthenticateResponse =
  | AuthenticateSuccessfulResponse
  | AuthenticateMfaChallengeResponse
  | AuthenticateFailureResponse;

export interface MfaExchangeRequest {
  mfaCode: string;
  mfaChallenge: string;
}

export type MfaExchangeResponse = AuthenticateResponse;

export interface MfaResendRequest {
  mfaCode: string;
}

export type MfaResendResponse = AuthenticateResponse;

export interface AuthenticateApiError {
  status?: AuthenticateStatus;
  apiErrorCode?: string;
  errorObject?: {
    subscriptionManagementLink?: string;
    subscriptionPaymentDueDays?: number;
  };
}
